import {
  CHAIN_TOKEN_ADDRESS_MAP,
  ChainID,
} from '@shared/constants/chains';
import { Address } from 'viem';

export const getTokenAddressByChainId = (chainId: ChainID): Address => {
  const tokenAddress = CHAIN_TOKEN_ADDRESS_MAP[chainId];
  if (!tokenAddress) {
    throw new Error(`Unsupported chainId: ${chainId}. Supported chains: ${Object.keys(CHAIN_TOKEN_ADDRESS_MAP).join(', ')}`);
  }

  return tokenAddress;
};
